/*
  Shopify newsletter and contact forms -> HubSpot contacts.

  Nine forms on this theme post to Shopify's /contact endpoint and nowhere else
  (footer, newsletter popup, newsletter section, email-signup banner, the two
  contact forms, ...). Since the HubSpot Ecommerce Bridge stopped syncing in
  March 2025 nothing from /contact reaches portal 7027845, so every one of those
  signups was invisible in HubSpot. This file captures them.

  Why it fires AFTER the redirect rather than on submit
  -----------------------------------------------------
  These are native {% form 'customer' %} forms: a full POST that navigates away.
  `_hsq` sends its beacon asynchronously, so pushing identify inside the submit
  handler races the unload and is lost more often than not. Taking the form over
  with preventDefault would fix the race but puts this file in the path of every
  signup on the site -- if it throws, the signup is gone.

  So the form is left completely alone. The email is stashed on submit, Shopify
  redirects back with ?customer_posted=true, and the identify fires on that load
  with no navigation pending. Worst case this file fails and the Shopify signup
  still completes exactly as before.

  identify() needs no HubSpot form GUID: HubSpot keys on email, so a known
  address updates that contact and an unknown one creates it. It only takes
  effect on the next tracked event, which is why trackPageView follows it --
  without that nothing arrives. Setting lifecyclestage alongside keeps these out
  of the empty-stage hole that the Contactable Leads segments miss; HubSpot does
  not move a stage backwards by default, so an existing customer who signs up to
  the newsletter is not demoted to lead.
*/
(function () {
  var STASH = 'carol-hs-pending';
  // A stash older than this is from an abandoned submit, not the redirect we
  // are waiting for, so it is dropped rather than attributed to a later visit.
  var MAX_AGE_MS = 10 * 60 * 1000;

  function marketCountry() {
    try {
      if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    } catch (error) {
      /* Shopify global absent on some templates; the property is optional. */
    }
    return '';
  }

  function stash(email) {
    try {
      sessionStorage.setItem(STASH, JSON.stringify({ email: email, at: Date.now() }));
    } catch (error) {
      /* Private mode or storage disabled. Nothing to capture, nothing to break. */
    }
  }

  function takeStash() {
    try {
      var raw = sessionStorage.getItem(STASH);
      if (!raw) return null;
      sessionStorage.removeItem(STASH);
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.email) return null;
      if (Date.now() - parsed.at > MAX_AGE_MS) return null;
      return parsed.email;
    } catch (error) {
      return null;
    }
  }

  function identify(email) {
    var hsq = (window._hsq = window._hsq || []);
    var props = { email: email, lifecyclestage: 'lead' };
    var country = marketCountry();
    if (country) props.country = country;
    hsq.push(['identify', props]);
    hsq.push(['trackPageView']);
  }

  function watchForms() {
    var inputs = document.querySelectorAll('input[name="contact[email]"]');
    Array.prototype.forEach.call(inputs, function (input) {
      var form = input.form;
      if (!form || form.getAttribute('data-carol-hs') === 'on') return;
      form.setAttribute('data-carol-hs', 'on');
      form.addEventListener('submit', function () {
        // No preventDefault: the native Shopify submission is untouched. The
        // browser has already enforced required/type=email by this point, so a
        // value here is one Shopify will accept.
        var value = (input.value || '').trim();
        if (value) stash(value);
      });
    });
  }

  function flush() {
    // Shopify appends customer_posted=true on a successful customer form post,
    // and that is the signal we want. But it is not guaranteed: a theme can post
    // to a different URL, an app can intercept the form, or the redirect can be
    // swallowed. Requiring the parameter turned every one of those into a silent
    // no-capture, which is the worst failure mode here -- the signup succeeds and
    // HubSpot never hears about it.
    //
    // So the stash itself is the trigger and the parameter is only a hint. A
    // submit event fires only after the browser has validated the field, and the
    // stash expires in MAX_AGE_MS, so the cost of firing without the parameter is
    // at worst an identify for a signup whose POST then failed. Capturing a lead
    // twice is harmless -- HubSpot keys on email. Losing one is not.
    var email = takeStash();
    if (email) identify(email);
  }

  function init() {
    watchForms();
    flush();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The newsletter popup and the cart drawer inject their markup after load, so
  // a one-shot query would miss them.
  if (window.MutationObserver) {
    new MutationObserver(watchForms).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
